import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Inject,
  DoCheck
} from '@angular/core';
import { MenuItem } from './drop-down-menu.types';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'wfm-drop-down-menu',
  templateUrl: './drop-down-menu.component.html',
  styleUrls: ['./drop-down-menu.component.scss']
})
export class DropDownMenuComponent implements AfterViewInit, DoCheck {
  @Input() isOpen: boolean;
  @Output() isOpenChange = new EventEmitter<boolean>();

  @Input() closeOnItemClick: boolean;

  @Input() name: string;

  @Input() menuItems: MenuItem[] = [];

  @Output() itemClick = new EventEmitter<MenuItem>();

  @ViewChild('container') container: ElementRef<any>;

  dropdownWidth: string;

  constructor(@Inject(DOCUMENT) private document) {}

  ngAfterViewInit() {
    this.document.defaultView.setTimeout(() => {
      this.dropdownWidth = `${this.container.nativeElement.offsetWidth}px`;
    }, 0);
  }

  ngDoCheck(): void {
    if (this.container && `${this.container.nativeElement.offsetWidth}px` !== this.dropdownWidth) {
      this.dropdownWidth = `${this.container.nativeElement.offsetWidth}px`;
    }
  }

  changeIsOpen(isOpen) {
    this.isOpen = isOpen;
    this.isOpenChange.emit(this.isOpen);
  }

  clickItem(item: MenuItem) {
    this.itemClick.emit(item);
    this.closeOnItemClick && this.changeIsOpen(false);
  }
}
